import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  accounts: 'Accounts',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.accounts],
  endpoints: {
    getAccounts: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(account => ({
                type: TAG_TYPES.accounts,
                id: account.id,
              })),
              { type: TAG_TYPES.accounts, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Accounts', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.accounts, id: 'LIST' }],
    },
    createAccount: {
      invalidatesTags: [{ type: TAG_TYPES.accounts, id: 'LIST' }],
    },
    updateAccount: {
      invalidatesTags: (result, error, { accountId }) => [
        { type: TAG_TYPES.accounts, id: 'LIST' },
        { type: TAG_TYPES.accounts, id: accountId },
      ],
    },
    createAccountTransfer: {
      invalidatesTags: (result, error, { body }) => [
        { type: TAG_TYPES.accounts, id: 'LIST' },
        { type: TAG_TYPES.accounts, id: body.fromAccountId },
        { type: TAG_TYPES.accounts, id: body.toAccountId },
      ],
    },
  },
})

export const {
  useGetAccountsQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useCreateAccountTransferMutation,
} = api
